import { DynamicConstants } from '@/constants';
import { ApolloLink, NormalizedCacheObject, ApolloClient, InMemoryCache } from '@apollo/client';
import useOidc from '@/composables/useOidc';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from '@apollo/client/link/error';
import { ToastContent } from 'vue-toastification/src/types';
import Vue from 'vue';
import ErrorToast from '@/components/ErrorToast.vue';

export let client: ApolloClient<NormalizedCacheObject> | null = null;

export default function useCreateGraphqlClient(constants: DynamicConstants) {
  const httpLink = createUploadLink({
    // You should use an absolute URL here
    uri: constants.apiUrl + 'graphql'
  }) as unknown as ApolloLink;

  const errorLink = onError(error => {
    if (error.graphQLErrors == null) return;
    if (error.graphQLErrors.length == 0) return;
    const data = error.graphQLErrors[0].extensions;
    if (data == null) return;
    const content: ToastContent = {
      component: ErrorToast,
      props: {
        error: data
      }
    };

    Vue.$toast(content, {
      toastClassName: 'alert alert-danger dismissable px-4 w-100'
    });
  });

  const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = useOidc().user.value?.access_token;
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ''
      }
    };
  });

  authLink.concat(errorLink);

  // Cache implementation
  const cache = new InMemoryCache();

  // Create the apollo client
  const apolloClient = new ApolloClient({
    link: authLink.concat(errorLink).concat(httpLink),
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache'
      }
    }
  });

  // Due to bug this does not work atm.
  apolloClient.defaultOptions = {
    query: {
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: false
    }
  };

  return (client = apolloClient);
}
